export default {
  init() {
    // JavaScript to be fired on all pages

    /*
    var $hamburger = $('.hamburger');
    $hamburger.on('click', function() {
      $hamburger.toggleClass('is-active');
      // Do something else, like open/close menu
      $('body').toggleClass('menu-open');
    });
    */

    /*
    detect scroll from top, apply class
    */
    $(document).scroll(function() {
      var value=$(document).scrollTop();

      var vHeight = window.innerHeight;
      var scrollHeight = vHeight / 5;

      if ( value >= scrollHeight ) {
        $('.banner').addClass('banner__scrolled');
        return;
      } else {
        $('.banner').removeClass('banner__scrolled');
      }
    });

    /*
     * scroll to end of header on button click
    */
    var vHeight = window.innerHeight;
    $('button.prompt').on('click', function(){
      $('html,body').animate({ scrollTop: vHeight }, 500);
    });

    //close mobile menu if clicking on jump menu
    $('a[href=\'#newsletter-block\']').on('click', function(){
      $( 'button.navbar-toggler.is-active' ).trigger( 'click' );
    });

    $('body').on('click', 'a[href*=\'#\']:not([href=\'#\'],[data-slide=\'prev\'],[data-slide=\'next\'],[data-toggle=\'collapse\'],[data-toggle=\'tab\'],[href=\'#tab\'])', function(e) {
        $('html, body').animate({scrollTop: $( $.attr(this, 'href') ).offset().top - 75}, 500);
        e.preventDefault();
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    //

    function isInViewport(node) {
      // Am I visible? Height and Width are not explicitly necessary in visibility
      // detection, the bottom, right, top and left are the essential checks. If an
      // image is 0x0, it is technically not visible, so it should not be marked as
      // such. That is why either width or height have to be > 0.
      var rect = node.getBoundingClientRect()
      return (
        (rect.height > 0 || rect.width > 0) &&
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
      )
    }

    var width = $(window).width();
    $(window).resize(function() {
      width = $(window).width();
    });

    $(window).on('scroll', function () {
      if (width >= 992){
        var scrolled = $(document).scrollTop();
        $('.parallax-background').each(function() {
          var initY = $(this).offset().top
          var height = $(this).height()
          //var endY = initY + $(this).height()
          // Check if the element is in the viewport.
          var visible = isInViewport(this)
          if(visible) {
            var diff = scrolled - initY
            var ratio = (diff / height) * 100
            $(this).css('background-position','center CALC(50% + ' + Math.floor((ratio * 3)) + 'px)')
          }
        })
        $('.parallax-carousel').each(function() {
          var initY = $(this).offset().top
          var height = $(this).height()
          //var endY = initY + $(this).height()
          // Check if the element is in the viewport.
          var visible = isInViewport(this)
          if(visible) {
            var diff = scrolled - initY
            var ratio = (diff / height) * 100
            $(this).find('.carousel-item').css('background-position','center CALC(50% + ' + Math.floor((ratio * 3)) + 'px)')
          }
        })
      }
    });

    $('.carousel.multi-slide').on('slide.bs.carousel', function (e) {
        /*
            CC 2.0 License Iatek LLC 2018 - Attribution required
        */
        var $e = $(e.relatedTarget);
        var idx = $e.index();
        var itemsPerSlide = 9;
        var totalItems = $('.carousel-item').length;

        if (idx >= totalItems-(itemsPerSlide-1)) {
          var it = itemsPerSlide - (totalItems - idx);
          for (var i=0; i<it; i++) {
            // append slides to end
            if (e.direction == 'left') {
              $('.carousel-item').eq(i).appendTo('.carousel-inner');
            }else {
              $('.carousel-item').eq(0).appendTo('.carousel-inner');
            }
          }
        }
    });

    $('.carousel').swipe({
        swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
          if (direction == 'left') $(this).carousel('next');
          if (direction == 'right') $(this).carousel('prev');
          console.log(fingerData);
        },
        allowPageScroll: 'vertical',
    });

    var pageNumber = 1;
    const ajax_posts = window.ajax_posts;

    function load_posts(cat){
        pageNumber++;
        var str = '&pageNumber=' + pageNumber + '&action=more_post_ajax';
        if(cat){
          str += '&cat=' + cat;
        }
        $.ajax({
          type: 'POST',
          dataType: 'html',
          url: ajax_posts.ajaxurl,
          data: str,
          success: function(data){
            var $data = $(data);
            if($data.length){
              $('#ajax-posts').append($data);
              $('#more_posts').attr('disabled',false);
            } else{
              $('#more_posts').attr('disabled',true);
            }
          },
          error : function(jqXHR, textStatus, errorThrown) {
            console.log(jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown);
          },
        });
        return false;
    }

    $('#more_posts').on('click',function(){ // When btn is pressed.
        $('#more_posts').attr('disabled', true); // Disable the button, temp.
        load_posts($(this).data('cat'));
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js